/* eslint-disable jsx-a11y/anchor-is-valid */
import './ChatTextArea.css';
import { useContext, useState } from 'react';
import { ConfigProvider } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Button } from 'antd';

interface ChatTextAreaProps {
  placeholder: string;
  loading: boolean;
  onMessageSent: (message: string) => void;
}

const ChatTextArea: React.FC<ChatTextAreaProps> = ({
  placeholder,
  loading,
  onMessageSent
}) => {
  const authContext = useContext(AuthenticationContext);

  const [message, setMessage] = useState('');

  const isReadOnly =
    authContext.authentication === null ||
    ![UserRole.owner, UserRole.admin, UserRole.maintainer].includes(
      authContext.authentication?.role
    );

  const isBtnDisabled = message.length === 0;

  const handleSendMessage = () => {
    setMessage('');
    onMessageSent(message);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && e.shiftKey) {
      e.preventDefault();
      setMessage(message + '\n');
    } else if (e.key === 'Enter') {
      if (message.length > 0) {
        handleSendMessage();
        e.preventDefault();
      }
    }
  };

  return (
    <div className="chat-text-area">
      <TextArea
        placeholder={placeholder}
        rows={2}
        style={{
          resize: 'none'
        }}
        disabled={isReadOnly}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <ConfigProvider
        theme={{
          token: {
            controlHeight: 56,
          },
        }}
      >
        <Button
          type="primary"
          disabled={
            isReadOnly
            || (isBtnDisabled
              && loading === false
            )}
          loading={loading}
          onClick={() => handleSendMessage()}
        >
          Envoyer
        </Button>
      </ConfigProvider>
    </div>
  );
};

export default ChatTextArea;
